define('modules/form_editor/models/input_text',['require','exports','module','./base_form_element'],function(require, exports, module){
  "use strict";
  var BaseFormElement = require("./base_form_element");
  module.exports = BaseFormElement.extend({
    name: "input:text",
    isSocialBindable: true,
    defaultValues: {
      "placeholder": "",
      "variable": "",
      "socialBinding": ""
    }
  });
});

